import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../hooks/usePostHook";
import CreateIcon from "../../icons/CreateIcon";
import { IComponent } from "../../types/interface";

const CreateComponentComponent = loadable(
  () => import("../../components/Components/Create")
);

export default function CreateComponent() {
  const { mutateAsync: createComponent, isLoading: isCreatingComponent } =
    usePostHook({
      queryKey: ["component"],
      navigateURL: "/website-builder/components",
    });

  const handleCreate = async (
    data: IComponent,
    setError: UseFormSetError<IComponent>
  ) => {
    try {
      const url = APIS.COMPONENT;
      await createComponent({
        url,
        formData: { ...data },
        setError,
      });
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Component
        </span>
      </div>
      <CreateComponentComponent
        handleCreate={handleCreate}
        isCreatingNavigation={isCreatingComponent}
      />
    </>
  );
}
